// extracted by mini-css-extract-plugin
export default {"colorOpt":"color-picker_colorOpt__4yOuU","element":"color-picker_element__xgnqZ","indicator":"color-picker_indicator__XvkhV"};